<template>

<div>
    <div class="reklamark">
        <div class="omr0"><div class="inner-omr0"><div class="pext budskap0"><b>www.tyskgrammatik.se</b></div></div></div>
        <div class="omr1"><div class="inner-omr1"><div class="pext budskap1"> Mängder av självrättande övningar online</div></div></div>
        <div class="omr2"><div class="inner-omr2"><div class="pext budskap2"> Tydliga förklaringar</div></div></div>
        <div class="omr3"><div class="inner-omr3"><div class="pext budskap3"> Kategoriserat och anpassat för skolundervisning</div></div></div>
    </div>
</div>



</template>

<script>
export default {
  name: 'Vy1',
  props: {
    msg: String
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.reklamark {
    width: calc(100vw - 463px);
    height: calc(100vh - 250px);
    margin: auto;
    background-color: white;
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    background: rgba(255, 255, 255, 0.8);

    -webkit-animation: mjukframkomst 0.5s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjukframkomst 0.5s;
    /*animation-delay: 2s;*/
    position: relative;
}

.omr0, .omr1, .omr2, .omr3 {
    height: 25%;
    width:100%;
    position: absolute;
}
.inner-omr0, .inner-omr1, .inner-omr2, .inner-omr3 {
    position: relative;
}

.omr0 {
    top:0;

}
.omr1 {
    top:25%;

}
.omr2 {
    top:50%;

}
.omr3 {
    top:75%;

}





@media (max-width: 1024px) {
    .reklamark {
        width: 100%;
    }
}

@media (max-height: 600px) {
    .reklamark {

    }
}

.pext {
    font-size: 2em;
    padding-top: 0.4em;
}

.budskap0{

    text-align: center;
    color: black;
    color: #2c3e50;
    /*padding-top: 1em;
    font-size: 2em;*/
}




.budskap1{
    -webkit-animation: mjuk1 1s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjuk1 1s;
    text-align: left;
    padding-left: 2em;


    /*font-family: serif;*/
    color: #2c3e50;
    /*top: calc(20% + 30px);*/
    /*position: absolute;*/
}


.budskap2{
    -webkit-animation: mjuk2 1.5s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjuk2 1.5s;
    right:0;

    padding-right: 2em;

    /*font-family: serif;*/
    color: #85453b;

    position: absolute;

}

.budskap3{
    -webkit-animation: mjuk3 2s; /* Safari 4.0 - 8.0 */
    /*-webkit-animation-delay: 2s;*/
    animation: mjuk3 2s;
    text-align: left;
    padding-left: 2em;


    /*font-family: serif;*/
    color: #2c2d01;
    position: absolute;
}


@media (max-height: 500px) {
    .pext {
    font-size:1em;
    padding-top: 0.1em;
    }
}

@media (max-width: 400px) {
    .pext {
    font-size:1em;
    }
}



/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukframkomst {
  0% {
      opacity: 0;
  }
  75% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@-webkit-keyframes mjuk1 {
  0% {
      opacity: 0;
  }
  80% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@-webkit-keyframes mjuk2 {
  0% {
      opacity: 0;
  }
  85% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}

@-webkit-keyframes mjuk3 {
  0% {
      opacity: 0;
  }
  90% {
      opacity: 0;
  }
  100% {
      opacity: 1;
  }
}



</style>
